import { css } from 'styled-components';
import { CFMixins } from '../../mixins';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseTabbedNavLabelTokens = {
    TYPE_SPEC: {
        DEFAULT: CFTokens.TYPE_SPEC_SCALE.C_MEDIUM_AUTO,
        FOCUSED: CFTokens.TYPE_SPEC_SCALE.C_BOLD_AUTO,
    },
};
//
// Helpers
//
export const CFBaseTabbedNavLabelHelpers = {
    color: ({ color }) => color,
    typeSpec: ({ focused }) => focused
        ? CFMixins.typeSpec(CFBaseTabbedNavLabelTokens.TYPE_SPEC.FOCUSED)
        : CFMixins.typeSpec(CFBaseTabbedNavLabelTokens.TYPE_SPEC.DEFAULT),
};
//
// Element Styles
//
export const CFBaseTabbedNavLabelStyles = {
    Root: css `
    color: ${CFBaseTabbedNavLabelHelpers.color};
    ${CFBaseTabbedNavLabelHelpers.typeSpec};
  `,
};
